import { init as dynamicFormInit } from './dynamic-forms';

document.addEventListener(
  'wpcf7mailsent',
  function (event) {
    //  Which form has been submitted?
    if (event.detail.contactFormId == 33) {
      document
        .querySelector('[data-js-contact-form]')
        .classList.add('u-is-hidden');
      document
        .querySelector('[data-js-contact-form-success]')
        .classList.remove('u-is-hidden');
      // clover.enquiry.init();
      // clover.enquiry.subscribe($('.contact-modal form'));
      //TODO: Subscription checkbox
      dataLayer.push({ event: 'contactFormSubmit' });

      if (
        $(this).find('input[name="newsletter[]"]').length &&
        $(this).find('input[name="newsletter[]"]').is(':checked')
      ) {
        var subscribeArgs = {};

        for (var i = 0; i < event.detail.inputs.length; i++) {
          switch (event.detail.inputs[i].name) {
            case 'contact-name':
              subscribeArgs['name'] = event.detail.inputs[i].value;
              break;
            case 'email':
              subscribeArgs['email'] = event.detail.inputs[i].value;
              break;
          }
        }

        $.ajax({
          type: 'POST',
          url: '/subscribe.php',
          data: subscribeArgs,
          cache: false,
          dataType: 'json',
        });
      }
    }
  },
  false
);

var $form = $('.wpcf7-form');
var $cf7 = $('.wpcf7');

$form.on('submit', function () {
  var $this = $(this);
  var $button = $this.find('button[type="submit"]');
  var $loader = $this.find('.c-form__loader');

  $button.attr('disabled', 'disabled');
  $loader.addClass('loading');
});

$cf7.on(
  'wpcf7invalid wpcf7mailfailed wpcf7mailsent wpcf7spam',
  function (event) {
    var $this = $(this);
    var $button = $this.find('button[type="submit"]');
    var $loader = $this.find('.c-form__loader');

    $button.removeAttr('disabled');
    $loader.removeClass('loading');
  }
);

var $subscriberPreferencesForm = $('#subForm');

if ($subscriberPreferencesForm) {
  var $this = $subscriberPreferencesForm;

  $this.on('submit', (e) => {
    $this.find('.c-form__loader').addClass('loading');
    $this.find('button').attr('disabled', 'disabled');
  });
}

/* Input type file */
var inputs = document.querySelectorAll('.c-input-file');

Array.prototype.forEach.call(inputs, function (input) {
  var label = input.parentNode.nextElementSibling,
    labelVal = label.innerHTML;

  input.addEventListener('change', function (e) {
    var fileName = '';
    if (this.files && this.files.length > 1)
      fileName = (this.getAttribute('data-multiple-caption') || '').replace(
        '{count}',
        this.files.length
      );
    else fileName = e.target.value.split('\\').pop();

    if (fileName) {
      label.querySelector('.c-input-file__placeholder').innerHTML = fileName;
      label
        .querySelector('.c-input-file__label')
        .classList.add('c-input-file__label--moved');
    } else label.innerHTML = labelVal;
  });
});

var movingInputs = document.querySelectorAll('.wpcf7-form-control');

Array.prototype.forEach.call(movingInputs, function (input) {
  var wrapper = input.parentNode.parentNode;

  input.addEventListener('change', function (e) {
    if (e.currentTarget.value) {
      if (!$(wrapper).hasClass('has-value')) {
        $(wrapper).addClass('has-value');
      }
    } else {
      $(wrapper).removeClass('has-value');
    }
  });
});

var fileUploads = document.querySelectorAll(
  '.wpcf7-form-control-wrap input[type=file]'
);
var maxUploadLimit = 25 * 1024 * 1024; // 25mb

Array.prototype.forEach.call(fileUploads, function (input) {
  var form = input.closest('form');
  var submit = form.querySelector('button[type=submit]');

  var errorContainer = document.createElement('div');
  errorContainer.classList.add('wpcf7-error-container');

  var errorMessage = document.createElement('span');
  errorMessage.classList.add('wpcf7-not-valid-tip');
  errorMessage.innerHTML =
    'The file(s) you attempted to upload exceeds our maximum file size of 25MB. Please compress your file or try uploading a smaller version.';

  input.closest('.wpcf7-wrapper').appendChild(errorContainer);

  input.addEventListener('change', function (e) {
    errorContainer.innerHTML = '';
    submit.removeAttribute('disabled');

    if (this.files.length > 0) {
      var totalFileSize = 0;
      for (var i = 0; i <= this.files.length - 1; i++) {
        totalFileSize += this.files.item(i).size;
      }
      if (totalFileSize >= maxUploadLimit) {
        errorContainer.appendChild(errorMessage);
        submit.setAttribute('disabled', true);
      }
    }
  });
});

dynamicFormInit();
